import axios from "axios";
import { useState, useEffect } from "react";
import LoadingHero from "../../assets/Assetstest/forumhero1.png";
import Loader from "../../components/loader/Loader";
import "./forum.css";
import { Link } from "react-router-dom";
import { PostItem } from "../../components/posts/PostItem";
import { delay } from "../../modules/setTimeout";
import dummy_post from "../../dummy_data/post.json";

export interface Post {
  likes: any;
  _id: string;
  id: string;
  thumbnail: string;
  category: string;
  title: string;
  description: string;
  creator: {
    avatar: any;
    _id: number;
    playerID: string | number;
    name: string;
  };
  createdAt: string;
  replies?: { user: { username: string; avatar: string }; createdAt: string }[];
  views?: number;
}

export const Forum = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [postCounts, setPostCounts] = useState({
    websupport: 0,
    gamesupport: 0,
    news: 0,
    updates: 0,
    discussion: 0,
    help: 0,
    lfg: 0,
  });


  useEffect(() => {
    const fetchPostCounts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/posts/forum`);
        setPostCounts(response.data);
      } catch (error) {
        console.error("Error fetching post counts:", error);
      }
    };

    fetchPostCounts();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div id="forum__hero">
      <img src={LoadingHero} alt="hero image Survival Interactive" />

      <section id="forum__body">
        <div id="forum">
          <div className="forum__title">
            <h1>Forum</h1>
          </div>

          <section className="forum__list">
            <ol className="forum__list--container">
              <li className="forum__list--support">
                <h2>
                  <a href="#">Support</a>
                </h2>

                <ol className="forum__items">
                  <li className="forum__items--details">
                    <div className="forum__logo">
                      <span className="forum__logo--span">
                        <i className="fa fa-comments"></i>
                      </span>
                    </div>
                    <div className="forum__main">
                      <h4 className="forum__main--title">
                        <Link to="./support/websupport">
                          Account & Technical Support
                        </Link>
                      </h4>
                      <div className="forum__main--detail">
                        <p className="forum__main--details">
                          Technical support for website, account issues.
                        </p>
                      </div>
                    </div>
                    <div className="forum__data">
                      <dl className="forum__data-list">
                        <dt className="forum__data--itemsAmount">
                        {postCounts.websupport || 0}
                        </dt>
                        <dd>posts</dd>
                      </dl>
                    </div>
                  </li>
                  <li className="forum__items--details">
                    <div className="forum__logo">
                      <span className="forum__logo--span">
                        <i className="fa fa-comments"></i>
                      </span>
                    </div>
                    <div className="forum__main">
                      <h4 className="forum__main--title">
                        <Link to="./support/gamesupport">
                          Bugs: Game, Forum, Website
                        </Link>
                      </h4>
                      <div className="forum__main--detail">
                        <p className="forum__main--details">
                          Please submit game bug reports here.
                        </p>
                      </div>
                    </div>
                    <div className="forum__data">
                      <dl className="forum__data-list">
                        <dt className="forum__data--itemsAmount">
                          {postCounts.gamesupport || 0}
                        </dt>
                        <dd>posts</dd>
                      </dl>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>

            <ol className="forum__list--container">
              <li className="forum__list--support">
                <h2>
                  <a href="#">NEWS & INFORMATION</a>
                </h2>

                <ol className="forum__items">
                  <li className="forum__items--details">
                    <div className="forum__logo">
                      <span className="forum__logo--span">
                        <i className="fa fa-comments"></i>
                      </span>
                    </div>
                    <div className="forum__main">
                      <h4 className="forum__main--title">
                        <Link to="./newsinformation/news">
                          News and Announcements
                        </Link>
                      </h4>
                      <div className="forum__main--detail">
                        <p className="forum__main--details">
                          Official updates from the Survival Interactive Team.
                        </p>
                      </div>
                    </div>
                    <div className="forum__data">
                      <dl className="forum__data-list">
                        <dt className="forum__data--itemsAmount">
                          {postCounts.news || 0}
                        </dt>
                        <dd>posts</dd>
                      </dl>
                    </div>
                  </li>
                  <li className="forum__items--details">
                    <div className="forum__logo">
                      <span className="forum__logo--span">
                        <i className="fa fa-comments"></i>
                      </span>
                    </div>
                    <div className="forum__main">
                      <h4 className="forum__main--title">
                        <Link to="./newsinformation/updates">
                        Survival Interactive Update Notes
                        </Link>
                      </h4>
                      <div className="forum__main--detail">
                        <p className="forum__main--details">
                          latest Survival Interactive changes and release info.
                        </p>
                      </div>
                    </div>
                    <div className="forum__data">
                    <dl className="forum__data-list">
                        <dt className="forum__data--itemsAmount">
                          {postCounts.updates || 0}
                        </dt>
                        <dd>posts</dd>
                      </dl>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>

            <ol className="forum__list--container">
              <li className="forum__list--support">
                <h2>
                  <a href="#">GAME DISCUSSION</a>
                </h2>

                <ol className="forum__items">
                  <li className="forum__items--details">
                    <div className="forum__logo">
                      <span className="forum__logo--span">
                        <i className="fa fa-comments"></i>
                      </span>
                    </div>
                    <div className="forum__main">
                      <h4 className="forum__main--title">
                        <Link to="./gamediscussion/discussion">
                        Survival Interactive Discussion
                        </Link>
                      </h4>
                      <div className="forum__main--detail">
                        <p className="forum__main--details">
                          General discussion about Survival Interactive.
                        </p>
                      </div>
                    </div>
                    <div className="forum__data">
                    <dl className="forum__data-list">
                        <dt className="forum__data--itemsAmount">
                          {postCounts.discussion || 0}
                        </dt>
                        <dd>posts</dd>
                      </dl>
                    </div>
                  </li>
                  <li className="forum__items--details">
                    <div className="forum__logo">
                      <span className="forum__logo--span">
                        <i className="fa fa-comments"></i>
                      </span>
                    </div>
                    <div className="forum__main">
                      <h4 className="forum__main--title">
                        <Link to="./gamediscussion/help">
                          Phoenix Helping Phoenix
                        </Link>
                      </h4>
                      <div className="forum__main--detail">
                        <p className="forum__main--details">
                          If you need a helping hand or can offer one, reach
                          out here!
                        </p>
                      </div>
                    </div>
                    <div className="forum__data">
                    <dl className="forum__data-list">
                        <dt className="forum__data--itemsAmount">
                          {postCounts.help || 0}
                        </dt>
                        <dd>posts</dd>
                      </dl>
                    </div>
                  </li>
                  <li className="forum__items--details">
                    <div className="forum__logo">
                      <span className="forum__logo--span">
                        <i className="fa fa-comments"></i>
                      </span>
                    </div>
                    <div className="forum__main">
                      <h4 className="forum__main--title">
                        <Link to="./gamediscussion/lfg">Looking For Guild</Link>
                      </h4>
                      <div className="forum__main--detail">
                        <p className="forum__main--details">
                          Find the perfect guild or recruit more members.
                        </p>
                      </div>
                    </div>
                    <div className="forum__data">
                    <dl className="forum__data-list">
                        <dt className="forum__data--itemsAmount">
                          {postCounts.lfg || 0}
                        </dt>
                        <dd>posts</dd>
                      </dl>
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </section>
        </div>
      </section>
    </div>
  );
};
